import React from 'react';

import { Box, Typography } from '@mui/material';
import Avatar from 'components/Avatar';

import { StyledProfileItemText, StyledProfileItemWrap } from './styled';

interface ProfileItemProps {
	avatarSrc?: string;
	label?: string;
	value: string;
}

function ProfileItem({ avatarSrc, label, value }: ProfileItemProps) {
	return (
		<StyledProfileItemWrap elevation={2}>
			{(avatarSrc || avatarSrc === null) && <Avatar alt={value} src={avatarSrc} />}
			<Box overflow="hidden">
				{label && <Typography variant="body2">{label}</Typography>}
				<StyledProfileItemText variant="subtitle1">{value}</StyledProfileItemText>
			</Box>
		</StyledProfileItemWrap>
	);
}

export default ProfileItem;
